import { resetRouter } from './routerInstance';
import getBasePath from 'owa-url/lib/getBasePath';
import registerRoute from './registerRoute';
import RouterOptions from './RouterOptions';
import initializeRouter from './initializeRouter';

export function switchVdirForRouter(
    vdir: string,
    registerRoutes: ((registerRouteFunction: typeof registerRoute) => Promise<void>) | undefined,
    routerOptions: RouterOptions | undefined
) {
    resetRouter();
    window.history.pushState(
        {},
        vdir,
        '/' + getBasePath(vdir.toLowerCase()) + window.location.search
    );
    return initializeRouter(routerOptions, registerRoutes, true);
}
